import bootstrap from "bootstrap/dist/js/bootstrap.bundle";

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.provide("bootstrap", bootstrap);

  nuxtApp.vueApp.directive("bs-tooltip", {
    mounted(el, binding) {
      el.setAttribute("data-bs-title", binding.value);
      // eslint-disable-next-line no-new
      new bootstrap.Tooltip(el, { trigger: "hover" });
    },
  });
});
